import React, { useState } from "react";
import { useTable } from "react-table";
import "../App.css";
import Swal from "sweetalert2";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const DataTable = ({ data, updateMyData }) => {
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [editingColumnId, setEditingColumnId] = useState(null);
  const [editValue, setEditValue] = useState("");
 

  const columns = React.useMemo(
    () => [
      { Header: "Material", accessor: "Material" },
      { Header: "Proveedor", accessor: "Proveedor" },
      { Header: "Precio", accessor: "precio proveedor" }, //del localStorage
      { Header: "Existencia Proveedor", accessor: "Existencia Proveedor" }, //del localStorage
      { Header: "Descripción", accessor: "Descripcion" }, //del localStorage
      { Header: "Orden", accessor: "Orden" },
    ],
    []
  );
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#00205b",
      color: theme.palette.common.white,
    },
  }));

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  

  const handleDoubleClick = (cell) => {
    if (
      cell.column.id === "Existencia Proveedor" ||
      cell.column.id === "precio proveedor" ||
      cell.column.id === "Proveedor" ||
      cell.column.id === "Material" ||
      cell.column.id === "Descripcion"
    ) {
      Swal.fire({
        title: "No editable",
        icon: "warning",
        confirmButtonColor: "#00205B",
        customClass: {
          container: "my-swal-zindex",
        },
      }).then((result) => {
        return;
      });
      return;
    }
    setEditingRowIndex(cell.row.index);
    setEditingColumnId(cell.column.id);
    setEditValue(cell.value);
  };

  const handleBlur = () => {
    const cleanedValue = editValue.toString().replace(/\D/g, "");
    updateMyData(
      editingRowIndex,
      editingColumnId,
      cleanedValue === "" ? 0 : parseInt(cleanedValue, 10)
    );
    setEditingRowIndex(null);
    setEditingColumnId(null);
  };

  const handleChange = (value) => {
    if (value !== "" && !/^\d+$/.test(value)) {
      return;
    }
    if (/\s/.test(value)) {
      return;
    }
    setEditValue(value);
  };

  return (
    <Table {...getTableProps()} style={{ border: "solid 1px blue" }}>
      <TableHead>
        {headerGroups.map((headerGroup) => (
          <TableRow {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <StyledTableCell {...column.getHeaderProps()}>
                {column.render("Header")}
              </StyledTableCell>
            ))}
          </TableRow>
        ))}
      </TableHead>
      <TableBody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <TableRow {...row.getRowProps()}>
              {row.cells.map((cell) => {
                const isEditing =
                  cell.row.index === editingRowIndex &&
                  cell.column.id === editingColumnId;
                return (
                  <TableCell
                    {...cell.getCellProps()}
                    // style={styles.celdaPedido2}
                    onDoubleClick={() => handleDoubleClick(cell)}>
                    {isEditing ? (
                      <TextField
                        type="text"
                        value={editValue}
                        onChange={(e) => handleChange(e.target.value)}
                        onBlur={handleBlur}
                        autoFocus
                        fullWidth
                      />
                    ) : (
                      cell.render("Cell")
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default DataTable;
